(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["knevio-offer-panel"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root) => {
    if (root.dataset.knevioBound === "true") return;
    const section = root.closest(".shopify-section") || document;
    const form = section.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    if (!form) return;
    root.dataset.knevioBound = "true";
    const variants = JSON.parse(root.querySelector("[data-knevio-variants]").textContent || "[]");
    const initial = variants.find(v => String(v.id) === form.querySelector('input[name="id"]')?.value) || variants[0];
    if (!initial) return;
    const colors = [...new Set(variants.map(v => v.option1))];
    const sizes = [...new Set(variants.map(v => v.option2))];
    const swatches = {Black:"#1c2421",Blue:"#172381",Green:"#3c8050",Orange:"#e67b3e"};
    const money = new Intl.NumberFormat("en-GB", {style:"currency",currency:root.dataset.currency || "GBP"});
    const cards = [...root.querySelectorAll(".knevio-offer")];
    const states = new Map();
    const selectCard = (card) => {
      card.querySelector(':scope > input[type="radio"]').checked = true;
      cards.forEach(c => {
        const selected = c.querySelector(':scope > input[type="radio"]').checked;
        c.querySelector(".knevio-item-options").hidden = !selected;
      });
    };
    cards.forEach((card, cardIndex) => {
      const offer = card.querySelector(':scope > input[type="radio"]');
      offer.setAttribute("aria-label",card.querySelector(".knevio-offer__title").textContent.trim());
      const qty = Number(offer.dataset.quantity);
      const price = Number(initial.price) / 100;
      const fixed = Number(offer.dataset.bundlePrice);
      const due = root.dataset.mode === "freebies" ? price * Number(offer.dataset.paid) : fixed;
      const rrp = Number(root.dataset.rrp) * qty;
      card.querySelector("[data-knevio-price]").textContent = money.format(due);
      card.querySelector("[data-knevio-compare]").textContent = money.format(rrp);
      const badge = card.querySelector("[data-knevio-savings]");
      if (badge) badge.textContent = "SAVE " + money.format(rrp-due) + " · " + Math.round((rrp-due)/rrp*100) + "% OFF";
      const options = document.createElement("div");
      options.className = "knevio-item-options";
      options.hidden = !offer.checked;
      card.append(options);
      const rows = Array.from({length:qty}, () => ({color:initial.option1,size:initial.option2}));
      states.set(card,rows);
      rows.forEach((selection,index) => {
        const row = document.createElement("div");
        row.className = "knevio-sleeve-row";
        const heading = document.createElement("span");
        heading.className = "knevio-sleeve-number";
        heading.textContent = "#" + (index+1);
        row.append(heading);
        const label = document.createElement("label");
        label.className = "knevio-row-size";
        label.textContent = "Size";
        const select = document.createElement("select");
        select.setAttribute("aria-label","Sleeve " + (index+1) + " size");
        sizes.forEach(size => {
          const option = document.createElement("option");
          option.value = size;
          option.textContent = size;
          option.selected = size === selection.size;
          select.append(option);
        });
        select.addEventListener("change", () => { selection.size = select.value; });
        label.append(select);
        row.append(label);
        const colorGroup = document.createElement("div");
        colorGroup.className = "knevio-row-colors";
        const caption = document.createElement("span");
        caption.className = "knevio-row-caption";
        caption.textContent = "Color: " + selection.color;
        colorGroup.append(caption);
        const buttons = document.createElement("div");
        buttons.className = "knevio-row-swatches";
        colors.forEach(color => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "knevio-row-swatch";
          button.style.setProperty("--swatch-color",swatches[color] || "#aaa");
          button.setAttribute("aria-label","Sleeve " + (index+1) + " color " + color);
          button.setAttribute("aria-pressed",String(color === selection.color));
          button.title = color;
          button.dataset.color = color;
          button.addEventListener("click", () => {
            selection.color = color;
            caption.textContent = "Color: " + color;
            buttons.querySelectorAll("button").forEach(b => b.setAttribute("aria-pressed",String(b === button)));
          });
          buttons.append(button);
        });
        colorGroup.append(buttons);
        row.append(colorGroup);
        options.append(row);
      });
      card.addEventListener("click", (event) => {
        if (event.target.closest(".knevio-item-options")) return;
        selectCard(card);
      });
      offer.addEventListener("change", () => selectCard(card));
    });
    const colorChange = (event) => {
      const target = event.target;
      if (!section.contains(target) || target.dataset.optionName !== "Color") return;
      cards.forEach(card => {
        states.get(card).forEach(selection => {selection.color = target.value;});
        card.querySelectorAll(".knevio-row-caption").forEach(caption => {caption.textContent = "Color: " + target.value;});
        card.querySelectorAll(".knevio-row-swatch").forEach(button => button.setAttribute("aria-pressed",String(button.dataset.color === target.value)));
      });
    };
    section.addEventListener("change",colorChange);
    const submitBundle = async (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      const card = cards.find(c => c.querySelector(':scope > input[type="radio"]').checked);
      const choice = card?.querySelector(':scope > input[type="radio"]');
      const status = root.querySelector("[data-knevio-status]");
      if (!card) return;
      const items = [];
      for (const selection of states.get(card)) {
        const variant = variants.find(v => v.option1 === selection.color && v.option2 === selection.size);
        if (!variant) {
          status.textContent = "Please choose an available colour and size for every sleeve.";
          return;
        }
        const item = items.find(item => item.id === Number(variant.id));
        if (item) item.quantity += 1;
        else items.push({id:Number(variant.id),quantity:1});
      }
      const button = form.querySelector('add-to-cart-component button');
      if (button?.disabled) return;
      if (button) button.disabled = true;
      status.textContent = "";
      try {
        const response = await fetch((window.Shopify?.routes?.root || "/") + "cart/add.js", {
          method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
          body:JSON.stringify({items})
        });
        if (!response.ok) {
          const problem = await response.json().catch(() => ({}));
          throw new Error(problem.description || "This selection could not be added. Please try again.");
        }
        await response.json();
        const route = window.Shopify?.routes?.root || "/";
        const code = choice.dataset.code;
        const discountResponse = await fetch(route + "cart/update.js", {
          method:"POST",
          headers:{"Content-Type":"application/json","Accept":"application/json"},
          body:JSON.stringify({
            ...(code ? {discount:code} : {}),
            sections:["cart-drawer-section"],
            sections_url:window.location.pathname
          })
        });
        if (!discountResponse.ok) {
          throw new Error("Your sleeves were added, but the bag could not refresh. Open the bag before adding again.");
        }
        const cartData = await discountResponse.json();
        const [{morphSection,sectionRenderer},{CartLinesUpdateEvent}] = await Promise.all([
          import("@theme/section-renderer"),import("@shopify/events")
        ]);
        const html = cartData.sections?.["cart-drawer-section"];
        if (html) {
          await morphSection("cart-drawer-section",html,{mode:"hydration",injectStylesheet:true});
        } else {
          await sectionRenderer.renderSection("cart-drawer-section",{cache:false,mode:"hydration",injectStylesheet:true});
        }
        const pending = CartLinesUpdateEvent.createPromise();
        const cartComponent = document.querySelector("#cart-drawer cart-items-component");
        (cartComponent || document).dispatchEvent(new CartLinesUpdateEvent({
          action:"add",context:"product",
          lines:items.map(item => ({merchandiseId:String(item.id),quantity:item.quantity})),
          promise:pending.promise
        }));
        pending.resolve({
          cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cartData),
          detail:{items:cartData.items,sections:cartData.sections,source:"knevio-bundle-picker",productId:root.dataset.productId}
        });
        await customElements.whenDefined("theme-drawer");
        document.getElementById("cart-drawer")?.open();
        if (code && cartData.discount_codes?.some(discount => discount.code.toUpperCase() === code.toUpperCase() && !discount.applicable)) {
          status.textContent = "Your sleeves are in your bag. The bundle discount could not apply; please check the total before checkout.";
        }
        if (button) button.disabled = false;
      } catch(error) {
        status.textContent = error.message;
        if (button) button.disabled = false;
      }
    };
    section.addEventListener("submit",event => {
      if (event.target === form) submitBundle(event);
    },true);
    section.addEventListener("click",event => {
      const button = event.target.closest('add-to-cart-component button');
      if (button && form.contains(button)) submitBundle(event);
    },true);
  };
  const initAll = () => document.querySelectorAll("[data-knevio-bundle-picker]").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded",initAll);
  else initAll();
  document.addEventListener("shopify:section:load",initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
